import React from 'react';
import Link from '../../../../../elements/Link';
import Icon from '../../../../../elements/icons/Icon';

export function PollOption({ href, icon, label }) {
    return (
        <Link href={href}>
            <div className="text-center">
                <Icon src={icon} />
                {label}
            </div>
        </Link>
    );
}
